/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_2_DescInputs */

const en_pc_rv_2_desc = /** @type {(inputs: Pc_Rv_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool placement, menus and shortcuts follow Photoshop more closely than any other look-alike. Most people find their way within minutes.`)
};

const zh_pc_rv_2_desc = /** @type {(inputs: Pc_Rv_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具位置、菜单和快捷键比其他任何仿制品都更贴近 Photoshop，多数人几分钟就能摸清。`)
};

/**
* | output |
* | --- |
* | "Tool placement, menus and shortcuts follow Photoshop more closely than any other look-alike. Most people find their way within minutes." |
*
* @param {Pc_Rv_2_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_2_desc = /** @type {((inputs?: Pc_Rv_2_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_2_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_2_desc(inputs)
	return zh_pc_rv_2_desc(inputs)
});
export { pc_rv_2_desc as "pc.rv.2.desc" }